import {
  AutoComplete,
  Avatar,
  Button,
  Drawer,
  Form,
  Input,
  Select,
  Spin,
} from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getPage, getParamValue } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import TopHeading from "./TopHeading";
import { debounce } from "lodash";
import Empty from "../common/Empty";
import AddAdmin from "./AddAdmin";
import AdminDetails from "./Details";
import { EditOutlined } from "@ant-design/icons";

const AdminList = () => {
  const [status, setStatus] = useState("");
  // const [mobileNumber, setMobileNumber] = useState("");
  const [fullName, setFullName] = useState("");
  const [limit, setLimit] = useState(16);
  const [visible, setVisible] = useState(undefined);
  const [adminData, setAdminData] = useState({
    loading: false,
    data: null,
  });
  const [selecteAdminForEdit, setSelecteAdminForEdit] = useState({
    loading: false,
    data: null,
  });
  const [adminsOptions, setAdminsOptions] = useState({
    loading: false,
    list: null,
  });
  const [selectedAdmin, setSelectedAdmin] = useState(undefined);

  const fetchRef = useRef(null);

  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");

  const reseAllFieldData = () => {
    setStatus("");
    setFullName("");
    form.resetFields();
  };

  const getAdmins = useCallback(async () => {
    setAdminData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_AUTH_API}`;
    axios
      .get(
        `${encodedUri}/admin/all/V2?` +
          `nameOrEmail=${fullName || ``}` +
          `&page=${page || 0}` +
          `&limit=${limit || 16}` +
          (status ? `&status=${status}` : ``),
        // (mobileNumber
        //   ? `&mobileNumber=%2B88${mobileNumber?.replace("+88", "")}`
        //   : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setAdminData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setAdminData({ loading: false, data: [] });
        console.error("Users: Error", err);
      });
  }, [limit, status, page, fullName]);

  const getAdminsOptions = useCallback(
    async (fullName) => {
      setAdminsOptions({ loading: true, list: null });
      const encodedUri = `${process.env.REACT_APP_AUTH_API}`;
      axios
        .get(
          `${encodedUri}/admin/all/V2?` +
            `nameOrEmail=${fullName || ``}` +
            `&page=${0}` +
            `&limit=${20}` +
            (status ? `&status=${status}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res) => {
          setAdminsOptions({
            loading: false,
            list: res.data?.admins?.map((admin: any) => ({
              label: admin.fullName,
              value: admin.fullName,
            })),
          });
        })
        .catch((err) => {
          setAdminsOptions({ loading: false, list: [] });
          console.error("Admins: Error", err);
        });
    },
    [status]
  );

  useEffect(() => {
    getAdmins();
  }, [getAdmins]);

  // const getAdminsOptionsDebounce = (mobileNumber) => {
  //   const fetcher = (mobileNumber) => {
  //     getAdminsOptions(mobileNumber);
  //   };

  //   return debounce(fetcher, 0.8);
  // };

  const getAdminsOptionsDebounce = React.useMemo(() => {
    const loadOptions = (value: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setAdminsOptions({ loading: false, list: null });

      if (fetchId !== fetchRef.current) {
        return;
      }

      getAdminsOptions(value);
    };

    return debounce(loadOptions, 800);
  }, []);

  useEffect(() => {
    if (visible) {
      setSelectedAdmin(undefined);
      setSelecteAdminForEdit(undefined);
    }
  }, [setSelectedAdmin, setSelecteAdminForEdit, visible]);

  useEffect(() => {
    setSelectedAdmin(undefined);
    setSelecteAdminForEdit(undefined);
  }, [visible]);

  const onClose = () => {
    setSelecteAdminForEdit(null);
    setSelectedAdmin(null);
    getAdmins();
  };

  return (
    <React.Fragment>
      <TopHeading {...adminData?.data?.totalElements} refetch={getAdmins} />
      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item name="search">
            <AutoComplete
              onSearch={getAdminsOptionsDebounce}
              onSelect={(val) => setFullName(val.toString())}
              options={adminsOptions?.list}
              defaultActiveFirstOption={false}
              notFoundContent={
                adminsOptions?.loading ? <Spin size="small" /> : null
              }
              style={{ width: 300 }}
            >
              <Input.Search
                size="large"
                placeholder="Search by Name"
                onSearch={(val) => setFullName(val)}
                enterButton
                loading={adminsOptions.loading}
                pattern={`[0-9]`}
                maxLength={11}
              />
            </AutoComplete>
          </Form.Item>

          {/* <Form.Item>
                  <Select
                    initialValues={status}
                    placeholder="Admin Status"
                    onChange={(val) => setStatus(val)}
                    value={status}
                    style={{ minWidth: 250 }}
                  >
                    <Option value={""}>ALL</Option>
                    <Option value={"VERIFIED"}>VERIFIED</Option>
                    <Option value={"WAITING_FOR_VERIFICATION"}>
                      WAITING FOR VERIFICATION
                    </Option>
                  </Select>
                </Form.Item> */}
        </Form>
        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>Full Name</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Email Address</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {adminData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {adminData?.data?.admins?.length ? (
                    adminData?.data?.admins?.map((admin: any, index: any) => (
                      <React.Fragment key={index}>
                        <div
                          className="single-product-wrapper"
                          onClick={() => setSelectedAdmin(admin?.email)}
                        >
                          <div className="single-product">
                            <Avatar src={admin?.profilePicture} size={40} className="mr-2 border" />
                            <span className="name text-capitalize">
                              {admin?.fullName}
                            </span>
                          </div>
                          <div className="single-product">
                            <span className="name">{admin?.email}</span>
                          </div>
                          <div className="single-product">
                            <span
                              className={`radius-btn ${
                                admin?.status ? "active" : "inactive"
                              }-btn`}
                            >
                              {admin?.status ? "Active" : "Inactive"}
                            </span>
                          </div>
                          <div className="single-product">
                            <Button
                              onClick={() => setSelecteAdminForEdit(admin)}
                            >
                              <EditOutlined />
                            </Button>
                          </div>
                        </div>
                      </React.Fragment>
                    ))
                  ) : (
                    <Empty data="Admins" />
                  )}
                </div>
              </div>
            )}
          </div>

          <Drawer
            title={selecteAdminForEdit ? "Edit Admin" : "Admin Details"}
            width={500}
            onClose={onClose}
            visible={selectedAdmin || selecteAdminForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            {selecteAdminForEdit ? (
              <AddAdmin
                adminDetails={selecteAdminForEdit}
                onCloseMethod={onClose}
              />
            ) : (
              <AdminDetails visibleData={selectedAdmin} refetch />
            )}
          </Drawer>

          <PaginationTwo
            {...adminData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default AdminList;
